import { type FC } from "react";
import { Flex } from "@chakra-ui/react";
import { Logo } from "./Logo";
import { useNavItems } from "./useNavItems";

export const DesktopHeader: FC = () => {
  const { leftNavItems, rightNavItems } = useNavItems();

  return (
    <>
      <Flex align="center" gap={6} h="full">
        <Logo monitor="desktop" />

        <Flex align="center" gap={6} h="full">
          {leftNavItems.map(({ Component, onClick, ...props }, index) => (
            <Component key={index} {...props} />
          ))}
        </Flex>
      </Flex>
      <Flex align="center" gap={6} h="full">
        {rightNavItems.map(({ Component, onClick, ...props }, index) => (
          <Component key={index} {...props} />
        ))}
      </Flex>
    </>
  );
};
